import React from "react";
import Tooltip from "./Tooltip";

export default function PowerblockAvailability({
  powerblockId,
  inverters,
  inverterCapacity,
  inverterStatus,
  converters,
  converterCapacity,
  converterStatus,
  batteries,
  batteryCapacity,
  batteryStatus,
  stale = false,
}) {
  const display = (value) => (value == null || value === '' ? '—' : value);
  const tooltipContent = (
    <div className="powerblock-availability-tooltip">
      <div><strong>Powerblock:</strong> {powerblockId}</div>
      <div><strong>Inverters:</strong> {display(inverters)} of {display(inverterCapacity)}</div>
      <div><strong>DCDC Converters:</strong> {display(converters)} of {display(converterCapacity)}</div>
      <div><strong>Battery Racks:</strong> {display(batteries)} of {display(batteryCapacity)}</div>
      {stale && <div><strong>Status:</strong> Stale — no dump timestamp</div>}
    </div>
  );

  return (
    <Tooltip position="top" content={tooltipContent}>
      <div className="powerblock-availability">
        <div className="powerblock-id">
          <span>{powerblockId}</span>
          {stale && <small className="badge text-bg-secondary ms-1">Stale</small>}
        </div>
        <div className={`powerblock-inverters ${inverterStatus}`}>
          <span>{display(inverters)}</span>/<span>{display(inverterCapacity)}</span>
        </div>
        <div className={`powerblock-converters ${converterStatus}`}>
          <span>{display(converters)}</span>/<span>{display(converterCapacity)}</span>
        </div>
        <div className={`powerblock-batteries ${batteryStatus}`}>
          <span>{display(batteries)}</span>/<span>{display(batteryCapacity)}</span>
        </div>
      </div>
    </Tooltip>
  );
}